import moment from 'moment'

// The single place table dates are formatted: DD/MM/YY HH:mm:ss, forced LTR so the
// numerals read left-to-right inside the RTL layout. Every table date column renders
// through here so they stay consistent.
export default function FormattedDate({ value }) {
    return (
        <div style={{ direction: 'ltr', whiteSpace: 'nowrap' }}>
            {moment(value).format('DD/MM/YY HH:mm:ss')}
        </div>
    )
}
